import React, {useEffect, useState} from 'react'
import {Link, useNavigate, useParams, useLocation} from 'react-router-dom'
import AddResTenant from './AddTenant/AddResTenant'
import AddComTenant from './AddTenant/AddComTenant'
import {get_Subdivions, list_tenant, Get_Tenants} from './Tenant_API'
import {PageTitle} from '../../../_metronic/layout/core'
import Swal from 'sweetalert2'
import {CircularProgress} from '@mui/material'
import PaginationComponent from '../PaginationComponent/Pagination'
import SearchProperty from '../property/SearchProperty'
import UpcomingTenants from './UpcomingTenants/UpcomingTenants'

interface tenantListDatatype {
  property_details: {
    property_id: number
    property_usage_type: number
    property_uuid: string
    propertytitle: string
    sub_unit_available: string
  }
  tenants: {
    accouont_holder_name: string
    contact_number: string
    email_id: string
    property_rent_due_date: string
    property_rent_end_date: string
    property_rent_rate: number
    property_rent_start_date: string
    property_usage_type: string
    sub_unit_available: string
    property_unit_name: string
    currency_code: string
    tenant_account_uuid: string
  }[]
}
interface subdivisionsDataType {
  property_sub_unit_uuid: string
  property_unit_description: string
  property_unit_max_tenants: number
  property_unit_name: string
  property_unit_rent: string
}
function TenantNewHome() {
  console.log('useParams', useParams(), useLocation())
  let {id} = useParams()
  let {search} = useLocation()
  const query = new URLSearchParams(search)
  const property_id = query.get('property_id')
  const navigate = useNavigate()
  const [showAddResTenantModal, setShowAddResTenantModal] = useState<boolean>(false)
  const [noDataFound, setNoDataFound] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [tenantList, setTenantList] = useState<tenantListDatatype>()
  const [tenantAPIData, setTenantAPIData] = useState<tenantListDatatype[]>([])
  const [additionalData, setAdditionalData] = useState<tenantListDatatype[]>([])
  const [tenants, setTenats] = useState<Boolean>(false)
  const [subDivisions, setSubDivisions] = useState<subdivisionsDataType[]>([])
  const [searchInputValue, setsearchInputValue] = useState<string>('')
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [dataLength, setDataLength] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10
  const pageCount = Math.ceil(dataLength / itemsPerPage)

  console.log('property_id', property_id, id)
  const getTenantsList = async () => {
    setNoDataFound(false)
    try {
      setLoading(true)
      const {data: res} = await list_tenant(id, itemOffset, itemsPerPage, searchInputValue)
      if (res.code === '200') {
        if (res.data.totalTenanats > 0) {
          setTenantList(res.data)
          setDataLength(res.data.totalTenanats)
        } else if (res.data.totalTenanats === 0) {
          setTenantList(res.data)
          setNoDataFound(true)
        }
      } else {
        setNoDataFound(true)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }
  async function checkSubDiv() {
    if (tenantList?.property_details?.sub_unit_available === 'YES') {
      try {
        const {data: res} = await get_Subdivions(id)
        if (res.code === '200') {
          setSubDivisions(res.data)
        } else if (res.code === '204') {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
            text: `${res.msg_details}. Please add the subdivision details first.`,
            allowOutsideClick: false,
          }).then((isConfirm) => {
            if (isConfirm.isConfirmed) {
              navigate(`/property/${id}/subdivisions`)
            } else {
              return
            }
          })
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
            text: res.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      }
    }
  }

  const getTenants = async () => {
    setNoDataFound(false)
    try {
      setLoading(true)
      const {data: res} = await Get_Tenants(property_id)
      if (res.code === '200') {
        console.log('entered')
        setTenantAPIData(res?.data)
        const parsedAdditionalData = res?.data.map((item: any) =>
          item?.additional_data ? JSON.parse(item.additional_data) : {}
        )

        // Set the parsed additional_data array in the state
        setAdditionalData(parsedAdditionalData)
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }

  console.log('tenantAPIData', tenantAPIData, additionalData)
  console.log('additionalData', additionalData)

  useEffect(() => {
    // if (!subDivisions) {
    checkSubDiv()
    // }
    return () => {
      Swal.close()
    }
  }, [tenantList])

  useEffect(() => {
    getTenantsList()
  }, [itemOffset, searchInputValue])

  useEffect(() => {
    getTenants()
  }, [])
  console.log('tenants', tenants)

  let userType = localStorage.getItem('user_type') || ''
  return (
    <>
      <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
        <div className='d-flex flex-column flex-column-fluid'>
          <div className='d-flex justify-content-between mb-5 ps-2'>
            <div className='d-flex flex-column'>
              <h1
                className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center mb-2'
              >
                Tenants
              </h1>
              {userType === 'Super Admin' ? (
                <ol className='breadcrumb text-muted fs-6 fw-bold'>
                  <li className='breadcrumb-item pe-3'>
                    <a href='/super_admin_property' className='pe-3'>
                      Tenants
                    </a>
                  </li>
                  <li className='breadcrumb-item pe-3'>
                    {tenantList?.property_details?.propertytitle}
                  </li>
                </ol>
              ) : (
                // <ol className='breadcrumb text-muted fs-6 fw-bold'>
                //   <li className='breadcrumb-item pe-3'>
                //     <a href='/property' className='pe-3'>
                //       Tenants
                //     </a>
                //   </li>
                //   <li className='breadcrumb-item pe-3'>{tenantList?.property_details?.propertytitle}</li>
                // </ol>
                <p className='breadcrumb text-muted fs-6 fw-bold'>
                  Property: {tenantList?.property_details?.propertytitle}
                </p>
              )}
            </div>
            <div className='row g-2 justify-content-end'>
              <div className='col-lg-4 col-12'>
                <SearchProperty
                  setCurrentPage={setCurrentPage}
                  setItemOffset={setItemOffset}
                  setsearchInputValue={setsearchInputValue}
                  placeholder='Tenant'
                />
              </div>
              <div className='col-lg-3 col-12'>
                <button
                  onClick={() => setShowAddResTenantModal(!showAddResTenantModal)}
                  className='btn btn-sm fw-bold btn-primary'
                >
                  {' '}
                  Add Tenant
                </button>
              </div>
              <div className='col-lg-4 col-12'>
                <button
                  onClick={() => setTenats(!tenants)}
                  className='btn btn-sm fw-bold btn-primary'
                >
                  {' '}
                  Onboard Lead
                </button>
              </div>

              {/* <input
                  data-kt-user-table-filter='search'
                  placeholder='Search Tenant'
                  className='col-lg-6 col-12 form-control form-control-solid border-2 py-2 px-4 border-secondary'
                  onChange={(e) => {
                    searchTenant(e.target.value)
                  }}
                /> */}

              {/* <button
                  onClick={() => setShowAddResTenantModal(!showAddResTenantModal)}
                  className='btn btn-sm fw-bold btn-primary col-lg-5 col-12'
                >
                  Add Tenant
                </button> */}

              {showAddResTenantModal && tenantList?.property_details?.property_usage_type === 2 ? (
                <AddComTenant
                  property_uuid={id}
                  show={showAddResTenantModal}
                  handleClose={() => setShowAddResTenantModal(false)}
                  getTenantsList={getTenantsList}
                  subDivisions={subDivisions}
                />
              ) : (
                <AddResTenant
                  property_uuid={id}
                  show={showAddResTenantModal}
                  handleClose={() => setShowAddResTenantModal(false)}
                  getTenantsList={getTenantsList}
                  subDivisions={subDivisions}
                />
              )}

              {tenants && (
                <UpcomingTenants
                  property_uuid={id}
                  show={tenants}
                  handleClose={() => setTenats(false)}
                  getTenantsList={getTenantsList}
                  getTenants={getTenants}
                  subDivisions={subDivisions}
                  additionalData={additionalData}
                  tenantAPIData={tenantAPIData}
                  tenatlist={tenantList?.property_details?.property_usage_type}
                />
              )}
            </div>
          </div>

          {loading ? (
            <div
              className='d-flex justify-content-center align-items-center vh-70'
              style={{height: '70vh'}}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              <div id='table div'>
                <div className={`card mb-5 mb-xl-8`}>
                  {/* begin::Body */}
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        {!noDataFound && (
                          <thead>
                            <tr className='fw-bold text-muted'>
                              {/* <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value='1'
                                data-kt-check='true'
                                data-kt-check-target='.widget-9-check'
                              />
                            </div>
                          </th> */}
                              <th className='min-w-150px'>Name</th>
                              <th className='min-w-150px'>Email</th>
                              <th className='min-w-100px'>Contact Number</th>
                              <th className='min-w-100px'>Actual Rent</th>
                              <th className='min-w-100px'>Actions</th>
                            </tr>
                          </thead>
                        )}
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {noDataFound ? (
                            <tr>
                              <td colSpan={5}>
                                <span className='d-flex flex-column align-items-center flex-start p-10'>
                                  <img
                                    src='/media/svg/undraw/tenant.svg'
                                    alt='No document uploaded'
                                    className='h-200px w-200px'
                                  />
                                  <span className='fw-bold text-muted fs-1 text-center'>
                                    No tenants present
                                  </span>
                                </span>
                              </td>
                            </tr>
                          ) : (
                            tenantList?.tenants?.map((tenant, index) => {
                              return (
                                <tr key={index}>
                                  {/* <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                      <input
                                        className='form-check-input widget-9-check'
                                        type='checkbox'
                                        value='1'
                                      />
                                    </div>
                                  </td> */}
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      {/* <div className='symbol symbol-45px me-3'>
                                          <span className='symbol symbol-50px me-2'>
                                            <span className='symbol-label bg-light-primary'>
                                                <i className='bi bi-house-door fs-2x btn btn-active-color-primary'></i>
                                            </span>
                                          </span>
                                        </div> */}
                                      <Link
                                        to={`/tenant/${tenant.tenant_account_uuid}/overview`}
                                        className='text-dark fw-bold text-hover-primary d-block fs-6'
                                      >
                                        {tenant.accouont_holder_name.charAt(0).toUpperCase() +
                                          tenant.accouont_holder_name.slice(1)}
                                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                          {tenant.property_unit_name}
                                        </span>
                                      </Link>
                                      {/* <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                      {tenant.accouont_holder_name.charAt(0).toUpperCase() +
                                        tenant.accouont_holder_name.slice(1)}
                                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {tenant.property_unit_name}
                                      </span>
                                    </div> */}
                                    </div>
                                  </td>
                                  <td>
                                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                      {tenant.email_id}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                      {tenant.contact_number}
                                    </span>
                                  </td>

                                  <td>
                                    <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                      {`${
                                        tenant.currency_code === 'INR' ? '₹' : tenant.currency_code
                                      } ${tenant.property_rent_rate}`}
                                    </span>
                                  </td>
                                  <td>
                                    <div className='d-flex flex-shrink-0'>
                                      <Link
                                        // to='#'
                                        to={`/tenant/${tenant.tenant_account_uuid}/overview`}
                                        className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      >
                                        <i
                                          className='bi bi-eye-fill bi-4x fs-2'
                                          title='View Property'
                                        ></i>
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}
                  </div>
                  {/* begin::Body */}
                </div>
              </div>
              {/* Begin: Pagination */}
              {tenantList && pageCount > 1 && (
                <PaginationComponent
                  itemsPerPage={itemsPerPage}
                  dataLength={dataLength}
                  setItemOffset={setItemOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  pageCount={pageCount}
                />
              )}
              {/* End: Pagination */}
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default TenantNewHome
